import { render } from "./CampaignManageListPage.vue?vue&type=template&id=2c29b228&lang=true"
import script from "./CampaignManageListPage.vue?vue&type=script&lang=js"
export * from "./CampaignManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__